import React, { useState, useEffect } from "react";
import axios from "axios";
import { environment } from "../../environment.js";
import { Button, Form, Modal } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import Loader from "../Components/Loader.js";
import Select from "react-select";
import Toggle from "react-toggle";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import Dropdown from "react-bootstrap/Dropdown";
import "./leadexe.css";
import NavbarNew from "../Components/NavbarNew.js";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const Lead = ({ history, match, props }) => {
  const [dap_users, setUsers] = useState([]);
  const [dap_firstName, setFirstName] = useState("");
  const [dap_lastName, setLastName] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_email, setEmail] = useState("");
  const [billable, setBillable] = useState("");
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_states, setDapState] = useState([]);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [leadid, setLeadid] = useState("");
  const [postcity, setPostCity] = useState("");
  const [poststate, setPostState] = useState("");
  const [toggleChecked, setToggleChecked] = useState(false);
  const [loader, setLoader] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    // console.log(device_id);
    // console.log("hello");
    // SetDeviceId(device_id);

    setShow(true);
  };
  let roles = [];
  roles = [
    {
      roleType: "Lead Executive",
      roleId: 1,
    },
  ];
  const [leadExecutives, setLeadExecutives] = useState([]);
  const [lead_executive_id, setLeadExecutiveId] = useState([]);
  const [createdBy, setCreatedById] = useState([]);
  // const dap_id = match.params.id;
  const toggle = () => {
    setToggleChecked(true);
  };
  useEffect((e) => {
    // e.preventDefault();
    // crm_api/getAllLeadExecutive
    // crm_api/getAllLeadExecutive
    axios
      .get(environment.dap_url + "crm_api/getAllActiveLeads")
      .then((res) => {
        const dap_users = res.data;
        console.log(res);
        setUsers(res.data);
        console.log(res.data);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });

    axios
      .get(environment.dap_url + "crm_api/getAllLeadExecutive")
      .then((res) => {
        // const dap_users = res.data;
        console.log(res);
        setLeadExecutives(res.data);
        console.log(res.data);
      })
      .catch(function (error) {
        MySwal.fire({
          title: <p>{error.message}</p>,
          type: "error",
        });
      });
  }, []);

  const setLeadExecutive = (e) => {
    console.log(e);
    setLeadExecutiveId(e.value);
    setCreatedById(e.createdBy);
  };

  const assignTo = (data) => {
    const { id, state } = data;
    console.log("hiio");
    console.log(id);
    setLeadid(id);
    handleShow();

    // Call the API with query parameters
    axios
      .get(environment.dap_url + `crm_api/getAllLeadExecutive?state=${state}`)
      .then((res) => {
        // Handle the response data
        console.log(res);
        setLeadExecutives(res.data);
        console.log(res.data);
      });
  };

  const deleteHandler = (id) => {
    // console.log(id);
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        axios
          .delete(environment.dap_url + "crm_api/DeleteLeads?Id=" + id)
          .then((res) => {
            console.log(res);
            MySwal.fire({
              title: <p>Lead has been successfully deleted!</p>,
              type: "success",
            });
            //history.push("/customers");
            axios
              .get(environment.dap_url + "crm_api/getAllActiveLeads")
              .then((res) => {
                setUsers(res.data);
              })
              .catch((err) => {});
          })
          .catch((err) => {
            MySwal.fire({
              title: (
                <p>{err?.response?.data?.message || "Lead deletion failed"}</p>
              ),
              type: "error",
            });
          });
      }
    });
  };

  const LeadExecutive = () => {
    // let id = match.params.id;

    console.log(createdBy);
    // console.log(leadleadid);
    setShow(false);
    // let device_id = deviceId;
    // let tenant_id = e.value;
    MySwal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(function (result) {
      if (result.isConfirmed) {
        console.log(leadid);
        // console.log(tenant_id.id);
        // console.log(device_id);
        axios
          .put(
            environment.dap_url + "crm_api/assignToLeadExecutive?id=" + leadid,
            {
              lead_executive_id: lead_executive_id,
              createdby: createdBy,
            }
          )
          .then((res) => {
            MySwal.fire({
              title: <p>Lead has been assigned successfully!</p>,
              type: "success",
            });
            // getAllNodeDevices();
          })
          .catch((err) => {
            MySwal.fire({
              title: <p>Lead couldn't be assigned at the moment</p>,
              type: "error",
            });
          });
      }
    });
  };

  const columns = [
    {
      dataField: "id",
      text: "#",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "organization",
      text: "Organization",
      sort: true,
    },
    {
      dataField: "userFirstName",
      text: "Name",
      sort: true,
      formatter: (row, cell, rowIndex, formatExtraData) => {
        return cell.userFirstName + " " + cell.userLastName;
      },
    },

    {
      dataField: "createdAt",
      text: "Date",
      sort: true,
      formatter: (dataField) => {
        let dateTimeArr = dataField.split("T");
        let dateArr = dateTimeArr[0].split("-");
        let dateFinal = dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
        return dateFinal;
      },
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },

    // {
    //   dataField: "phone",
    //   text: "Phone",
    //   sort: true,
    // },

    {
      dataField: "state",
      text: "State",
      sort: true,
    },
    // {
    //   dataField: "city",
    //   text: "City",
    //   sort: true,
    // },
    {
      dataField: "createdBy",
      text: "Lead Executive",
      sort: true,
      formatter: (_, row, rowIndex, formatExtraData) => {
        if (row.executive_details.length > 0) {
          return (
            row.executive_details[0].userFirstName +
            " " +
            row.executive_details[0].userLastName
          );
        }
        return "";
      },
    },
    {
      dataField: "ParentId",
      text: "Partner",
      sort: true,
      formatter: (_, row, rowIndex, formatExtraData) => {
        if (row.parent_details.length > 0) {
          return (
            row.parent_details[0].userFirstName +
            " " +
            row.parent_details[0].userLastName
          );
        }
        return "";
      },
    },

    // {
    //   dataField: "billable",
    //   text: "Billable",
    //   sort: true,
    //   formatter: (dataField) => {
    //     return (
    //       <Toggle
    //         id="cheese-status"
    //         checked={dataField}
    //         disabled={true}
    //         onChange={(e) => toggle(e)}
    //       />
    //     );
    //   },
    // },
    {
      dataField: "package",
      text: "Package",
      sort: true,
    },
    {
      dataField: "_id",
      text: "Assign To",
      sort: false,
      formatter: (cell, row) => {
        return (
          <div>
            <Button
              variant="primary"
              className="btn-sm"
              onClick={() => assignTo({ id: cell, state: row.state })}
            >
              Assign To
            </Button>
          </div>
        );
      },
    },

    {
      dataField: "_id",
      text: "Action",
      sort: false,
      formatter: (dataField) => {
        return (
          // <div>
          //   <Button
          //     variant="danger"
          //     className="btn-sm"
          //     onClick={() => deleteHandler(dataField)}
          //   >
          //     Delete <i className="fa fa-trash-o"></i>
          //   </Button>
          //   <LinkContainer to={`/leads/edit/` + dataField}>
          //     <Button variant="info" className="btn-sm">
          //       Edit <i className="fa fa-edit "></i>
          //     </Button>
          //   </LinkContainer>
          //   <LinkContainer to={`/leads/view/` + dataField}>
          //     <Button variant="light" className="btn-sm">
          //       View <i className="fa fa-eye"></i>
          //     </Button>
          //   </LinkContainer>
          //   {/* <LinkContainer to={`/subscriptions/create/` + dataField}>
          //     <Button variant="success" className="btn-sm">
          //       Subscriber <i className="fa fa-users"></i>
          //     </Button>
          //   </LinkContainer> */}
          // </div>
          <div>
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                Action
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href={`/leads/view/` + dataField}>
                  <i className="fa fa-eye"></i>&nbsp; &nbsp; View
                </Dropdown.Item>
                <Dropdown.Item onClick={() => deleteHandler(dataField)}>
                  <i className="fa fa-trash"></i>&nbsp; &nbsp; Delete
                </Dropdown.Item>
                {/* <Dropdown.Item href={`/subscriptions/create/` + dataField}>
                  <i className="fa fa-users"></i>&nbsp; &nbsp; Subscriber
                </Dropdown.Item> */}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          // <div class="dropdown">
          //   <button>...</button>
          //   <div class="dropdown-options">
          //     <a href="/leads/edit" + {dataField}>Edit</a>
          //     <a href="#">View</a>
          //     <a href="#">Delete</a>
          //   </div>
          // </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ];

  return (
    <div>
      <>
        <div className="container-fluid">
          <NavbarNew />
          <h4 className="card-title">LEADS</h4>
          <ToolkitProvider
            keyField="id"
            bootstrap4
            data={dap_users}
            columns={columns}
            search
          >
            {(props) => (
              <div>
                <div className="d-flex align-items-center">
                  <p className="mb-2 mr-2">Search in table:</p>
                  <SearchBar {...props.searchProps} />
                </div>
                <BootstrapTable
                  defaultSorted={defaultSorted}
                  pagination={paginationFactory()}
                  {...props.baseProps}
                  wrapperClasses="table-responsiv"
                />
              </div>
            )}
          </ToolkitProvider>
        </div>

        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            {/* <Modal.Title> {deviceData.deviceName} </Modal.Title> */}
          </Modal.Header>
          <Modal.Body>
            <Form className="mx-auto" show={show} onHide={handleClose}>
              <Form.Group controlId="AccessToken">
                {/* <Form.Label> Lead Executive Id </Form.Label> */}
                <Modal.Body>
                  <Form.Label>Lead Executive </Form.Label>
                  <Select
                    options={leadExecutives.map((element) => ({
                      id: element._id,
                      value: element._id,
                      label: element.userFirstName + " " + element.userLastName,
                      createdBy: element.createdBy,
                    }))}
                    // defaultValue="hi there"
                    // value={}
                    placeholder={"Lead Executive"}
                    // placeholder={deviceData.accessToken}
                    onChange={(e) => setLeadExecutive(e)}
                  />
                </Modal.Body>
              </Form.Group>
            </Form>

            <div className="my-2 d-flex justify-content-between align-items-center mx-auto">
              <div className=" mx-auto">
                <Button
                  type="submit"
                  className="btn btn-block btn-primary btn-sm font-weight-medium auth-form-btn"
                  onClick={() => {
                    LeadExecutive();
                  }}
                >
                  Save
                </Button>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light btn-sm" onClick={handleClose}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
};

export default Lead;
